<template>
  <div class="md-layout">
    <!-- 主菜单表格 -->
    <div class="md-layout-item " :class="{'md-size-50': hasSub,'md-size-100': !hasSub}">
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_class")}}</add-button>
          <md-table v-model="tableData" @md-selected="table_selectMainMenu">
            
            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
              <md-table-cell :md-label="$I18n('id')" class="numbers">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop
                  @click="table_editItem(item)"
                  class="md-just-icon md-round md-info left-icon"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop
                  @click="table_deleteItem(item)"
                  class="md-just-icon md-round md-danger md-info"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 子菜单表格 -->
    <div class="md-layout-item md-size-0" :class="{'md-size-50': !!selectedMain.id }">
      <md-card >
        <md-card-content>
          <add-button @click="table_addSubItem">{{$I18n("add_attr")}}</add-button>
          <md-table v-if="subTableData" v-model="subTableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <!-- <md-table-cell :md-label="$I18n('id')" class="numbers">{{ item.id }}</md-table-cell> -->
              <md-table-cell :md-label="$I18n('attr_name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('attr_code')">{{ item.key }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop
                  @click="table_editSubItem(item)"
                  class="md-just-icon md-round md-info left-icon"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop
                  @click="table_deleteSubItem(item)"
                  class="md-just-icon md-round md-danger md-info"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete' && openModalType!=='sub-delete'"
      @submit= "modal_submit"
      @close = "modal_classicModalHide"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete' || openModalType==='sub-delete'">{{$I18n("check_delete", modalData.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else-if="openModalType === 'add' || openModalType === 'edit'">
          <!-- 名字 -->
          <modal-form-item :label='$I18n("name") ' :required="true">
            <md-field :class="{'md-error' : error.name}">
              <md-input v-model="modalData.name"/>
              <md-icon v-if="error.name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- 图片 -->
          <modal-form-item :label='$I18n("icon")'>
            <div class="file-input">
              <div v-if="!imageRegular">
                <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}">
                  <img :src="regularImg" title="" />
                </div>
              </div>
              <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}" v-else>
                <img :src="imageRegular" />
              </div>
              <div class="">
                <md-button class="md-info md-round md-fileinput">
                  <template v-if="!imageRegular">{{$I18n("upload_img")}}</template>
                  <template v-else>{{$I18n("upload_img")}}</template>
                  <input ref="file_input" type="file" @change="onFileChange" />
                </md-button>
              </div>
            </div>
          </modal-form-item>
        </div>
        <div v-else>
          <!-- 名字 -->
          <modal-form-item :label='$I18n("attr_name") ' :required="true">
            <md-field :class="{'md-error' : error.name}">
              <md-input v-model="modalData.name"/>
              <md-icon v-if="error.name">clear</md-icon>
            </md-field>
          </modal-form-item>
          <!-- CODE -->
          <modal-form-item :label='$I18n("attr_code") ' :required="true">
            <md-field :class="{'md-error' : error.key}">
              <md-input v-model="modalData.key"/>
              <md-icon v-if="error.key">clear</md-icon>
            </md-field>
          </modal-form-item>
          <modal-form-item  :label='$I18n("attr_value")' :required="true">
            <md-field>
              <md-chips
                v-model="modalData.value"
                class="md-info"
                :md-placeholder="$I18n('input_in_this')"
              ></md-chips>
            </md-field>
          </modal-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fruits:[],
      imageRegular : "",
      regularImg : "/img/image_placeholder.jpg",

      hasSub : false, // 是否要显示子菜单表格
      selectedMain: {}, // 正在选择的主菜单的 子菜单列表

      // 表格相关
      icon  : "assignment",
      title : this.$I18n("stock_type_mng"),
      tableData : [], // 表格数据
      subInitTableData : [],
      // 是否打开弹窗
      openModal: false,
      openModalType : "add", // "delete" | "edit" | "sub-add" | "sub-edit" | "sub-delete"
      // 弹窗相关
      modalTitle : "",
      allMenus : [],
      error: {
        name: false,
      },
      modalData : { },
      currentPage : 1,
      pageSize : 10,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
  },
  computed: {
    subTableData(){
      return this.subInitTableData.map((item, index) => {
        return {
          ...item,
          index,
        }
      })
    },
    // 选择了的主菜单的子菜单数组
    selected(){
      if(this.selectedMain.sub_menus) {
        return this.selectedMain.sub_menus;
      } else {
        return [];
      }
    },
    // 弹窗里的菜单表格数据
    tableMenus(){
      return [...this.allMenus].splice((this.currentPage-1) * this.pageSize, this.pageSize);
    },
    // 选中的 菜单的数组 (包含 父节点id)
    selectedMenus() {
      let res = this.checkboxData.map(item => {
        return parseInt(item);
      });
      this.tableMenus.forEach(item => {
        if(res.includes(parseInt(item.menu_id)) && !res.includes(item.par_menu_id)){
          res.push(item.par_menu_id);
        }
      });
      return res;
    },
  },
  methods: {
    ...({ // 上传图片相关
      removeImage () {
        this.$refs.file_input.value = ""
        this.imageRegular = "";
      },
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files  || !files.length) return;
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.imageRegular = e.target.result;
        };

        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.img = res.data;
            reader.readAsDataURL(files[0]);
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      clickInput(){
        this.$refs.file_input.click();
      },
    }),
    // 选择主菜单
    table_selectMainMenu(item){
      if (item){
        this.selectedMain = item;
        this.api_getPageDataOnlySub()
        this.hasSub = true;
      } else{
        this.selectedMain = {};
        setTimeout(() => {
          if(this.selected.length === 0){
            this.hasSub = false;
          }
        },500)
      } 
    },
    // 获取页面信息
    api_getPageData(){
      //获取菜单
      this.$api.getGoodClass({})
        .then(this.$Then(res => {
          this.tableData = res.data;
          this.total = res.data.length;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableData = [];
          this.total = 0;
        }))
    },
    // 获取页面信息(但只更改子节点菜单)
    api_getPageDataOnlySub() {
      let main_id = this.selectedMain.id;
      //获取菜单
      this.$api.getGoodClass({})
        .then(this.$Then(res => {
          this.total = res.data.length;

          res.data.forEach(item => {
            if(item.id == main_id){
              this.subInitTableData = JSON.parse(item.attr)
              this.selectedMain.attr = item.attr
              this.tableData.map(tableItem => {
                if(tableItem.id == main_id){
                  tableItem.attr = item.attr
                }
              })
            }
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.subInitTableData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      if (this.openModalType === "add" || this.openModalType === "edit" || this.openModalType === "delete"){
        this.api_getPageData();
      }else {
        this.api_getPageDataOnlySub();
      }
      this.error = {};
    },
    // 新增角色
    table_addItem  (){
      this.modalTitle = this.$I18n("add_class");
      this.openModalType = "add";
      this.modalData = {
        name : "",
        img : "",
      };
      this.error = {
        name: false,
      }
      this.$refs.modal.open();
    },
    // 修改角色
    table_editItem (item){
      this.modalTitle = this.$I18n("edit_class");
      this.openModalType = "edit";
      this.modalData = {...item};
      this.$refs.value = item.img;
      this.imageRegular = item.img;
      this.error = {
        name: false,
      }
      this.$refs.modal.open();
    },
    // 删除角色
    table_deleteItem (item){
      this.modalTitle = this.$I18n("is_sure_del");
      this.openModalType = "delete";
      this.modalData = {...item};
      this.$refs.modal.open();
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType === "delete"){
        this.modal_submitDel();
      } else if (this.openModalType === "add") {
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){
        this.modal_submitEdit();
      } else if (this.openModalType === "sub-add") {
        this.modal_submitSubAdd();
      } else if (this.openModalType === "sub-edit"){
        this.modal_submitSubEdit();
      } else if (this.openModalType === "sub-delete"){
        this.modal_submitSubDel();
      }
    },
    modal_submitAdd () {
      if(!this.modalData.name){
        this.error.name = true;
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }

      this.$api.addGoodClass({
        name :this.modalData.name ,
        img  :this.modalData.img ,
        id : 0,
        parent_category_id : 0,
        attr:this.modalData.attr ?this.modalData.attr :"[]",
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    modal_submitEdit () {
      if(!this.modalData.name){
        this.error.name = true;
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }

      this.$api.editGoodClass({
        name :this.modalData.name ,
        img  :this.modalData.img ,
        id : this.modalData.id ,
        parent_category_id : 0,
        attr:this.modalData.attr ?this.modalData.attr :"[]",
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitDel (){
      this.$api.delGoodClass({
        name :this.modalData.name ,
        img  :this.modalData.img ,
        id : this.modalData.id ,
        parent_category_id : 0,
        attr:this.modalData.attr ?this.modalData.attr :"{}",
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
    table_addSubItem() {
      this.modalTitle = this.$I18n("add_attr");
      this.openModalType = "sub-add";

      this.modalData = {
        name : "",
        key  : "",
        value: [],
      };
      this.error = {
        name : false,
        ket  : false, 
      }
      this.$refs.modal.open();
    },
    // 修改角色
    table_editSubItem (item){
      // console.log(item)
      this.modalTitle = this.$I18n("edit_attr");
      this.openModalType = "sub-edit";
      this.modalData = {
        ...item,
        value : item.value ? item.value :[],
      };
      this.$refs.modal.open();
    },
    // 删除角色
    table_deleteSubItem (item){
      this.modalTitle = this.$I18n("del_attr");
      this.openModalType = "sub-delete";
      this.modalData = {...item};
      this.$refs.modal.open();
    },
    modal_submitSubAdd (){
      this.error.name = !this.modalData.name 
      this.error.key = !this.modalData.key   
      for(let key in this.error){
        if(this.error[key]){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return;
        }
      }
      this.error.name = this.subTableData.some(item => item.name == this.modalData.name);
      this.error.key =  this.subTableData.some(item => item.key == this.modalData.key  );
      for(let key in this.error){
        if(this.error[key]){
          this.$errorMsg(this.$I18n("pls_check_verify_3"));
          return;
        }
      }
      if(!this.modalData.value ||this.modalData.value.length == 0){
        this.$errorMsg(this.$I18n("pls_check_verify_4"));
        return;
      }
      let attr = this.subTableData
      attr.push(this.modalData)
      this.$api.editGoodClass({
        name :this.selectedMain.name ,
        img  :this.selectedMain.img ,
        parent_category_id : 0,
        id : this.selectedMain.id ,
        attr: JSON.stringify(attr.map(item => ({
          key  : item.key,
          name : item.name,
          value: item.value,
        }))),
      })
        .then(this.$Then(() => {
          this.api_getPageDataOnlySub()
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitSubEdit (){
      this.error.name = !this.modalData.name 
      this.error.key = !this.modalData.key   
      for(let key in this.error){
        if(this.error[key]){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return;
        }
      }
      this.error.name = this.subTableData.some(item => item.name == this.modalData.name && this.modalData.index != item.index);
      this.error.key =  this.subTableData.some(item => item.key == this.modalData.key   && this.modalData.index != item.index);
      for(let key in this.error){
        if(this.error[key]){
          this.$errorMsg(this.$I18n("pls_check_verify_3"));
          return;
        }
      }
      if(!this.modalData.value ||this.modalData.value.length == 0){
        this.$errorMsg(this.$I18n("pls_check_verify_4"));
        return;
      }

      let attr = this.subTableData
      this.$api.editGoodClass({
        name :this.selectedMain.name ,
        img  :this.selectedMain.img ,
        id : this.selectedMain.id ,
        parent_category_id : 0,
        attr: JSON.stringify(attr.map(item => {
          if(item.index != this.modalData.index){
            return item;
          }else{
            return this.modalData
          }
        }).map(item => ({
          key:item.key,
          name:item.name,
          value:item.value,
        }))),
      })
        .then(this.$Then(() => {
          this.api_getPageDataOnlySub()
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitSubDel (){
      let attr = this.subTableData
      this.$api.editGoodClass({
        name :this.selectedMain.name ,
        img  :this.selectedMain.img ,
        parent_category_id : 0,
        id : this.selectedMain.id ,
        attr: JSON.stringify(attr.filter(item => {
          return item.index != this.modalData.index
        }).map(item => ({
          key:item.key,
          name:item.name,
          value:item.value,
        }))),
      })
        .then(this.$Then(() => {
          this.api_getPageDataOnlySub()
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-layout {
    overflow: hidden;
  }
  .md-layout-item.md-size-0.md-size-50{
    right: 0;
  }
  .md-layout-item.md-size-0{
    position: relative;
    right: -10000px;
    transition: all 1s;
  }
  .md-layout-item {
    transition: all .5s;
  }
  // 弹窗内组件

  //表格里的多选框
    .checkbox-color{
      color: #9c27b0  !important;
    }
    .table-checkbox {
      width: 80px;
    }
    .table-checkbox  .md-checkbox{
      margin: 0;
    }
    .table-selected{
      text-align: left;
      width: 100%;
    }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗的表单
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px ;
    text-align: left;
  }
  .md-layout-left{
    text-align: left;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 100px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon {
    margin-right: 20px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>